import { Component } from '@angular/core';
import { Customer } from '../../../models/customer/customer';
import { CustomerService } from '../../../models/customer/customerService';
import {
  Page,
  TableViewAbstractComponent,
} from '../../ui/filterable-table/tableViewAbstractComponent';
import { UIErrorHandler } from '../../../core/uiErrorHandler';
import { SearchFilters } from '../../../models/search/searchFilters';
import { AccessManager } from '../../ui/access-manager/access-manager';

@Component({
  selector: 'app-customer-table-view',
  templateUrl: './customer-table-view.component.html',
  standalone: false,
})
export class CustomerTableViewComponent extends TableViewAbstractComponent {
  canEditCustomers: boolean = false;
  loading = false;
  constructor(
    public customerService: CustomerService,
    public uiErrorHandler: UIErrorHandler,
    private access: AccessManager
  ) {
    super();

    this.access.getUserAccess(AccessManager.AUTH_UPDATE_MERCHANT_CUSTOMERS).then((canEdit) => {
      this.canEditCustomers = canEdit[AccessManager.AUTH_UPDATE_MERCHANT_CUSTOMERS];
    });
  }

  ngOnInit() {
    this.access
    .getUserAccess([ AccessManager.AUTH_UPDATE_ALL_CUSTOMERS ])
    .then((accessRecord) => { this.canEditCustomers = accessRecord[AccessManager.AUTH_UPDATE_ALL_CUSTOMERS]; })
    
  }

  getRecordFromDataSource(customerId: string): Customer {
    for (var i = 0; i < this.dataSource.data.length; i++) {
      if (this.dataSource.data[i].id == customerId) {
        return this.dataSource.data[i];
      }
    }

    throw 'Customer not found in dataset';
  }

  getPageOfData(
    query: string,
    filters: any[],
    pageNum: number,
    pageSize: number,
    sortColumn: string,
    sortDirection: string,
  ): Promise<Page<Customer>> {
    this.loading = true;
    return this.customerService.getPaged(query, {
      pageNum: pageNum,
      pageSize: pageSize,
      orderBy: 'name',
      sortColumn: sortColumn,
      sortDirection: sortDirection,
      merchantId: this.options.merchantId ? this.options.merchantId : '',
      customerId: this.options.customerId ? this.options.customerId : '',
    }).finally(() => this.loading = false);
  }

  canQuery(): boolean {
    return this.options.merchantId != '';
  }

  _selectRow_click(id: string) {
    if (this.options.selectAction != 'none') {
      this.selectRow_click(id);
    }
  }

  deleteRow_click(id: string) {
    if (confirm('Are you sure you want to delete this customer?')) {
      this.customerService
        .deleteCustomer(id)
        .then((response: boolean) => {
          if (response) {
            this.reload('', new SearchFilters({}), 0, this._pageSize);
          } else {
            this.uiErrorHandler.handleError('Failed to delete customer');
          }
        })
        .catch((message) => {
          this.uiErrorHandler.handleError(message);
        });
    }
  }
}
